<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="info" [src]="'assets/images/secondinfo.png'"
        [srcset]="'assets/images/secondinfo@2x.png 2x, assets/images/secondinfo@3x.png 3x'" alt="logo" />
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-header">
        {{this.textService.keyValueMapping('errorPerantLeaveNokOkPageHeader', 'Maalesef işleminize devam edemiyoruz.',
        sdkInitTexts)}}
      </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label class="service-error-message">
        {{this.textService.keyValueMapping('errorPerantLeaveNokOkPageDescription', '18 yaşın altında olduğun için bu işlem öncesi veli onayına ihtiyacımız var. Paycell uygulamasındaki “Veli Beyan” menüsünden onay sürecini başlatabilirsin.', sdkInitTexts)}}
      </label></div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <pa-redirect></pa-redirect>
    </div>
  </div>
</div>
